<template>
  <div class="page-container">
    <div class="page-content">
      <facial-reader ref="reader" :on-read="(data) => validCode(data)" :processing="isProcessing" />
      <facial-filter ref="filter" v-show="!onReady" @filter="(data) => setFilter(data)" @close="handleFilterClose" />
      <facial-result ref="result" :filter="filterTags" @next="handleNext" @openFilter="showFilter"/>
    </div>
    <div class="page-footer">
      <router-link class="text" :to="{ name: routeHomeName }">
        <i class="icon bx bx-home"></i>
        Home
      </router-link>
    </div>
  </div>
</template>

<script>
import { CHECK_IN_PAGE_INDEX } from '@/modules/check-in/routes'
import FacialReader from '@/modules/check-in/pages/facial/facial-reader'
import FacialFilter from '@/modules/check-in/pages/facial/facial-filter'
import FacialResult from '@/modules/check-in/pages/facial/facial-result'
import { mapState, mapActions } from 'vuex'
import { CHECK_IN_MODULE } from '@/modules/check-in'

export default {
  name: 'facial',
  components: { FacialResult, FacialFilter, FacialReader },
  data () {
    return {
      routeHomeName: CHECK_IN_PAGE_INDEX,
      filterTags: [],
      onReady: false,
      isProcessing: false
    }
  },
  computed: {
    ...mapState(CHECK_IN_MODULE, {
      filterOptions: state => state.tags.list
    })
  },
  methods: {
    ...mapActions(CHECK_IN_MODULE, ['loadTagsList']),
    setFilter (filter) {
      this.filterTags = filter
      localStorage.setItem('filterTags', JSON.stringify(filter))
      if (this.$refs.reader && this.$refs.reader.ready) {
      }
    },
    handleFilterClose () {
      if (this.$refs.reader && this.$refs.reader.ready) {
      }
    },
    handleNext () {
      this.onReady = false
    },
    showFilter () {
      this.onReady = false
      if (this.$refs.filter) {
        this.$refs.filter.showSelectFilter()
      } else {
        console.error('Referência $refs.filter não encontrada.')
      }
    },
    restoreFilter () {
      const savedFilter = localStorage.getItem('filterTags')
      if (savedFilter) {
        this.filterTags = JSON.parse(savedFilter)
        if (!this.onReady && this.$refs.filter) {
          this.$refs.filter.showSelectFilter()
        }
      }
    },
    handleVisibilityChange () {
      if (document.visibilityState === 'visible') {
        this.restoreFilter()
      }
    },
    async validCode (data) {
      this.onReady = true
      this.isProcessing = true

      try {
        const code = { facial: data.photo, success: true }
        await this.$refs.result.validateCode(code)
        // Só aqui o backend terminou
        if (!code.success && this.$refs.reader) {
          console.log('Falha na validação. Reiniciando detecção.')
        }
      } catch (err) {
        console.error('Erro na validação facial', err)
        // opcional: mostrar toast de erro
      } finally {
        this.onReady = false
        this.isProcessing = false
      }
    }
  },
  mounted () {
    this.$store.dispatch('event/LoadOnceSetting')
    if (this.filterOptions) {
      this.$refs.filter.showSelectFilter()
    }
    this.restoreFilter()
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #E5E5E5;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1;
  padding: 0;
  position: relative;
}

.page-footer {
  background-color: #292F42;
  display: grid;
  place-items: center;
  min-height: 64px;

  .text {
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: 300;

    .icon {
      font-size: 32px;
    }
  }
}
</style>
